/* eslint-disable no-throw-literal */
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    fetchTimeout,
    saveJobBasic,
    useInterval,
    RehydrateThumbnails,
    updateLayoutAll,
    encodeJobNumber,
} from "../components/Common";
import { API_BASE } from "../AppConfig";

// Material UI
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import CloseIcon from "@material-ui/icons/Close";
import LinearProgress from "@material-ui/core/LinearProgress";
import Slide from "@material-ui/core/Slide";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import deepPurple from "@material-ui/core/colors/deepPurple";

// Components
import Designer_ToolBar from "./main_drawer/Designer_ToolBar";
import LayoutDesigner from "./layout/PaperDesigner";
import QuoteFrame from "./main_drawer/QuoteFrame";
import DocumentFrame from "./main_drawer/DocumentFrame";
import BOMFrame from "./main_drawer/BOMFrame";
// import RecallDrawer from './main_drawer/RecallDrawer';
import SpecificationToolDrawer from "./specification_drawer/SpecToolDrawer";
import HeaderBar from "./HeaderBar";

// Redux Actions
import { connect } from "react-redux";
import {
    changePage,
    updateDesigner,
    updateAPP,
    SHOW_DESIGNER_MESSAGE,
    setDesignerLoadingBackdrop,
    UPDATE_DESIGNER,
    SHOW_LOADING_BACKDROP,
} from "../redux_store/appState";
import { setToolSetArea, updateDocumentData } from "../redux_store/appStateHelper";
import { updateBOMData, updateJobParameter, updateJobIfRequired, updateCustomer } from "../redux_store/jobState";
import { saveJob } from "../redux_store/jobState";
import * as APP from "../redux_store/appState";
import { loadOffering } from "../redux_store/configState";
import DisplayOptions3D from "./layout/DisplayOptions3D";
import * as JOBSTATE_VALIDATION from "../redux_store/jobState_Validation";
import BSL_Dialog from "../components/BSL_Dialog";
import OrderJobPanel from "./main_drawer/OrderJobPanel";
import AreaSelector from "./specification_drawer/AreaSelector";
import LockBar from "./LockBar";
import { BSL_HelpLysaght } from "../components/BSL_HelpLysaght";
import { updateLayout2D } from "../redux_store/appStateHelper";
import { GetShapeUpdateString, GetColourUpdateString } from "./layout/PaperFunctionHelper";
import DesignerDrawingWarnings from "./DesignerDrawingWarnings";
import { GenerateARModal } from "./layout/Babylon3D";
import { getD365CustomerCodes } from "../helper/Helper";
import NewJob from "../components_main/NewJob/NewJob";

const importedActions = { changePage, updateDesigner, saveJob, updateBOMData, updateDocumentData };
const mapStateToProps = (state) => ({
    app: state.app,
    job: state.job,
});

const drawerWidth = 600;
const toolDrawerWidth = 160;

const styles = (theme) => ({
    root: {
        display: "flex",
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 36,
    },
    hide: {
        display: "none",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: "nowrap",
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: theme.spacing(7 + 1),
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(7 + 1),
        },
    },
    toolDrawerOpen: {
        backgroundColor: "rgba(242,245,251, 0.5)",
        width: toolDrawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    toolDrawerClose: {
        backgroundColor: "rgba(242,245,251, 0.5)",
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
        width: theme.spacing(7 + 1),
        [theme.breakpoints.up("sm")]: {
            width: theme.spacing(7 + 1),
        },
    },
    toolbar: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "0 8px",
        minHeight: "48px",
        ...theme.mixins.toolbar,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        height: "100%",
    },
    purpleAvatar: {
        margin: 5,
        color: "#fff",
        backgroundColor: deepPurple[500],
    },
    grow: {
        flexGrow: 1,
        font: "22pt 'Futura', sans-serif",
        textAlign: "left",
    },
    drawerPaper: {
        backgroundColor: "rgba(242,245,251, 0.6)",
        width: 160,
    },
    toolMenuText: {
        textAlign: "right",
    },
    toolListItem: {
        paddingRight: "0px",
        minWidth: toolDrawerWidth,
    },
    snackbar: {
        zIndex: "10100",
        backgroundColor: "#ff9800",
    },
    calculating: {
        color: "#ffffff",
        position: "fixed",
        zIndex: "10000",
        fontSize: "7pt",
        paddingLeft: "84px",
        bottom: "-1px",
    },
    bom: {
        position: "fixed",
        zIndex: "10001",
        left: "0px",
        top: "0px",
        height: "100%",
        width: "60%",
        borderRadius: "0px",
        textAlign: "left",
        display: "flex",
        background: "white",
    },
    display_options: {
        position: "fixed",
        zIndex: "1400",
        right: "0px",
        top: "0px",
        height: "100%",
        width: "380px",
        borderRadius: "0px",
        textAlign: "left",
        display: "flex",
        backgroundColor: "#edf0f3e8",
        borderLeft: "3px solid #0000001f",
        backdropFilter: "blur(4px)",
    },

    bom2: {
        position: "fixed",
        zIndex: "10001",
        left: "0px",
        top: "0px",
        height: "100%",
        width: "60%",
        borderRadius: "0px",
        textAlign: "left",
        display: "flex",
        background: "white",
        "& .react-resizable-handle": {
            position: "absolute",
            width: 20,
            height: "100%",
            top: 0,
            bottom: 0,
            right: 0,
            background:
                "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+')",
            backgroundPosition: "right center",
            padding: "0 3px 3px 0",
            "background-repeat": "no-repeat",
            "background-origin": "content-box",
            "box-sizing": "border-box",
            cursor: "e-resize",
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
    dragger: {
        width: "5px",
        cursor: "ew-resize",
        padding: "4px 0 0",
        borderTop: "1px solid #ddd",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        zIndex: "100",
        backgroundColor: "#c7ccd0",
        "-webkit-user-drag": "none",
        "&:hover": {
            backgroundColor: "#a7aca0",
        },
    },
    selectPointNote: {
        maxWidth: "450px",
        textAlign: "left",
        top: "100px",
        padding: "10px",
        background: "#d7751bab",
        position: "absolute",
        right: "12px",
        zIndex: "5",
        color: "white",
    },
});

function Designer(props) {
    const SHOW_CUSTOMER_JOB_PANEL = props.app.designer[APP.SHOW_CUSTOMER_JOB_PANEL];
    const dispatch = useDispatch();
    const job = useSelector((state) => state.job);
    const app = useSelector((state) => state.app);
    const config = useSelector((state) => state.config);
    const user_data = useSelector((state) => state.app.user);
    const SHOW_DIALOG = app?.designer?.[APP.SHOW_DIALOG];
    const job_distributor = useSelector((state) => state?.job?.Distributor?.Code);
    const threeDMiniMode = useSelector((state) => state.app.designer[APP.THREED_MINI_MODE]);
    const quoteParams =
        JSON.stringify({
            ...job?.QuoteParameters,
            ENGINEERING: null,
        }) +
        JSON.stringify(job?.SiteParameters) +
        JSON.stringify(job?.Customer) +
        job?.Status +
        job?.OrderStatus +
        job?.OverrideEngineering;

    const [open, setOpen] = React.useState(false);
    const [warningsContinue, setWarningsContinue] = React.useState(false);
    const [message, setMessage] = React.useState(false);
    const [bomOpen, setBomOpen] = React.useState(false);
    const [fast, setFast] = React.useState(false);
    const [openingQuote, setOpeningQuote] = React.useState(false);
    const [openingOrder, setOpeningOrder] = React.useState(false);
    const {warningMessages, setWarningMessages} = props
    const [quoteOpen, setQuoteOpen] = React.useState(false);
    const [documentOpen, setDocumentOpen] = React.useState(false);
    const [orderOpen, setOrderOpen] = React.useState(false);
    const [shouldSave, setShouldSave] = React.useState(false);
    const [engineeringStatus, setEngineeringStatus] = React.useState(null);
    const [engineeringLoading, setEngineeringLoading] = React.useState(false);
    const [isResizing, setIsResizing] = React.useState(false);
    const [lastDownX, setLastDownX] = React.useState(0);
    const [newWidth, setNewWidth] = React.useState({
        width: window.innerWidth > 1400 ? 1300 : "100%",
    });

    const carportMode = job?.DesignParameters?.CarportMode === 1;
    let job_loaded = props?.job?.id ? true : false;

    const handleMousedown = (e) => {
        setLastDownX(e.clientX);
        setIsResizing(true);
        window.isDesignerResizing = true;
    };

    React.useEffect(() => {
        const onVisibilityChange = (e) => {
            if (!document.hidden) {
                dispatch(updateJobIfRequired(job?.App?.Locked ? true : false));
            }
        };

        document.addEventListener("visibilitychange", onVisibilityChange, false);
        return () => {
            document.removeEventListener("visibilitychange", onVisibilityChange);
        };
    }, []);

    React.useEffect(() => {
        const encodedJobId = encodeJobNumber(job?.id);
        const currentBrandRedirect = window.location.href.split("app/")[0] + "app?3d-viewer&job=" + encodedJobId;

        if (job && job?.brandRedirect !== currentBrandRedirect)
            dispatch(
                updateJobParameter(
                    "brandRedirect",
                    currentBrandRedirect
                )
            );
    }, [job]);

    React.useEffect(() => {
        if (quoteOpen === true && !carportMode) {
            GenerateARModal();
        }
    }, [quoteOpen]);

    React.useEffect(() => {
        let get_tier = false;
        if (app?.user?.Role >= 0 && job?.Distributor?.LYVESAccount !== app?.user?.BusinessDetails?.LYVESAccount) {
            get_tier = job?.Distributor?.LYVESAccount;
        }
        if (
            job?.Customer?.DistLevel &&
            job?.Customer?.DistLevel !== "Retail" &&
            job?.Customer?.DistLevel !== job?.Distributor.LYVESAccount
        ) {
            get_tier = job?.Customer?.DistLevel;

            // Get the D365 Code if it hasn't been updated and state is live
            get_tier = getD365CustomerCodes({ job, app, config, dispatch, updateCustomer, get_tier });
        }

        if (get_tier) {
            if (!app?.pricefile_tier || app.pricefile_tier.LYVESAccount !== get_tier) {
                dispatch(setDesignerLoadingBackdrop("Loading Prices for Pricing Account: " + get_tier));

                let config_url = API_BASE() + `admin/GetePricing?account=` + encodeURIComponent(get_tier);
                fetchTimeout(config_url, {
                    method: "GET",
                })
                    .then(async (response) => {
                        if (response?.status && response.status >= 200 && response.status <= 300) {
                            let json = await response.json();
                            json.LYVESAccount = get_tier;

                            dispatch(updateAPP("pricefile_tier", RehydrateThumbnails(json))).then(() => {
                                dispatch({
                                    type: UPDATE_DESIGNER,
                                    parameter: SHOW_LOADING_BACKDROP,
                                    value: false,
                                });
                            });
                        } else {
                            throw {
                                message: "Could not generate layout at this time. Please wait a moment and try again.",
                            };
                        }
                    })
                    .catch((e) => {
                        dispatch({
                            type: SHOW_DESIGNER_MESSAGE,
                            message: "Error: Getting Pricing Error",
                        });
                        dispatch({
                            type: UPDATE_DESIGNER,
                            parameter: SHOW_LOADING_BACKDROP,
                            value: false,
                        });
                    });
            }
        }
    }, [job?.Customer?.DistLevel, job?.Distributor?.LYVESAccount]);

    React.useEffect(() => {
        const onVisibilityChange = (e) => {
            if (!document.hidden) {
                dispatch(updateJobIfRequired(job?.App?.Locked ? true : false));
            }
        };

        document.addEventListener("visibilitychange", onVisibilityChange, false);
        return () => {
            document.removeEventListener("visibilitychange", onVisibilityChange);
        };
    }, []);

    React.useEffect(() => {
        if (props?.job?.id && props?.job?.SiteParameters?.WindZoneAS1170 === null && !SHOW_CUSTOMER_JOB_PANEL) {
            dispatch(updateDesigner(APP.SHOW_CUSTOMER_JOB_PANEL, true));
            openMessageBox({
                title: "Wind data not valid",
                message: "Wind Data is not valid. Please confirm before proceeding.",
            });
        }
    }, [props.job, SHOW_CUSTOMER_JOB_PANEL]);

    React.useEffect(() => {
        if (window.innerWidth < 1350 && newWidth?.width !== "100%")
            setNewWidth({ width: window.innerWidth > 1400 ? 1300 : "100%" });
        if (window.innerWidth > 1350 && newWidth?.width === "100%")
            setNewWidth({ width: window.innerWidth > 1400 ? 1300 : "100%" });
    }, [window.innerWidth]);

    React.useEffect(() => {
        const setFromEvent = (e) => {
            if (!window.isDesignerResizing) return;

            let offsetLeft = e.clientX + 2;
            setNewWidth({ width: offsetLeft });
            window.designer_dragger_left = offsetLeft; // not a fan of using window global, but was taking too long to work out how to pass to handleMouseUo below.
        };

        window.addEventListener("mousemove", setFromEvent);

        return () => {
            window.removeEventListener("mousemove", setFromEvent);
        };
    }, []);

    React.useEffect(() => {
        const handleMouseUo = (e) => {
            if (window.isDesignerResizing) {
                let offsetLeft = e.clientX + 2;
                if (offsetLeft < 300) offsetLeft = 300;
                if (offsetLeft > document.body.offsetWidth - 80) offsetLeft = document.body.offsetWidth - 80;
                setNewWidth({ width: offsetLeft });
            }
            window.isDesignerResizing = false;
        };
        window.addEventListener("mouseup", handleMouseUo);

        return () => {
            window.removeEventListener("mouseup", handleMouseUo);
        };
    }, []);

    const [openDialog, setOpenDialog] = React.useState(false);
    const [dialogData, setDialogData] = React.useState([]);

    const openMessageBox = (dialogData) => {
        setDialogData(dialogData);
        setOpenDialog(true);
    };

    const closeMessageBox = () => {
        setOpenDialog(false);
        dispatch(updateDesigner(APP.SHOW_DIALOG, false));
    };

    // Run every time job is opened // loaded
    useEffect(() => {
        if (job?.preprod === true && !job?.App?.Locked && !window.location.href.includes("preprod")) {
            openMessageBox({
                title: "JOB WAS CREATED IN PREPROD",
                message:
                    "Warning ⚠️ this job was created in preprod. If testing please switch enviroments. Proceed with discretion.",
            });
        }
    }, [job_loaded]);

    useEffect(() => {
        if (SHOW_DIALOG) {
            setDialogData(app?.designer?.DIALOG_DATA);
            setOpenDialog(SHOW_DIALOG);
        }
    }, [SHOW_DIALOG]);

    const [triggerCustoomerFormClose, setTriggerCustoomerFormClose] = React.useState(false);

    let colour_change = GetColourUpdateString(true);
    let shape_update = GetShapeUpdateString(true);

    useEffect(() => {
        setShouldSave(true);
    }, [colour_change, shape_update]);

    useEffect(() => {
        setTimeout(function () {
            saveJobBasic(job, true, user_data);
            setShouldSave(false);
        }, 2000);
    }, [quoteParams]);

    useEffect(() => {
        setTriggerCustoomerFormClose(false);
    }, [triggerCustoomerFormClose]);

    useEffect(() => {
        if (job_distributor) {
            dispatch(loadOffering());
        }
    }, [job_distributor]);

    useInterval(() => {
        if (shouldSave) {
            saveJobBasic(job, false, user_data);
            setShouldSave(false);
        }
    }, 10000);

    useInterval(() => {
        if (document.hidden) return;
        if (job?.App?.Locked && !window.requestingControl) {
            dispatch(updateJobIfRequired());
        }
    }, 5000);

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setOpen(false);
    };

    const overrideEngineeringAction = () => {
        let message =
            "You, " +
            app.user.DisplayName +
            " of " +
            app.user.BusinessDetails.Name +
            ", agree to TAKE RESPONSIBLITY FOR THE DESIGN OF THIS JOB outside of the engineering scope of this system.";
        setDialogData({
            // error: true,
            title: "Authorise Engineering Override.",
            message: [<>{message}</>],
            primaryActionText: "I Authorise Override",
            primaryAction: () => {
                dispatch(updateJobParameter("OverrideEngineering", "ENG OVERRIDE APPROVED BY " + app.user.DisplayName));
            },
            secondaryActionText: "Cancel",
            secondaryAction: () => {},
        });

        setOpenDialog(true);
    };

    const continueWarningAction = ({ title, message, primaryActionText, tertiaryActionText }) => {
        return new Promise((resolve, reject) => {
            let dialog = {
                title,
                message,
                primaryActionText,
                primaryAction: () => {
                    resolve();
                },

                tertiaryActionText,
                tertiaryAction: reject(),
            };

            setDialogData(dialog);

            setOpenDialog(true);
        });
    };

    const continueEngineeringAction = ({ user, adminOnly, MaxResultsText, confirmEngineeringAction }) => {
        return new Promise((resolve, reject) => {
            let dialog = {
                title: "Engineering Not Passed",
                message: [
                    <>
                        {user.Role < 10 && adminOnly
                            ? "Please confirm engineering (a green tick) before proceeding."
                            : "Access to documents has been limited until engineering passes. Do you want to continue?"}
                        <br />
                        {MaxResultsText ? MaxResultsText : ""}
                    </>,
                ],

                primaryActionText: user.Role < 10 && adminOnly ? "Cancel" : "Continue",
                button1Id: "Continue-Engineering",
                primaryAction: () => {
                    if (user.Role < 10 && adminOnly) {
                        reject();
                    } else {
                        resolve();
                    }
                },

                tertiaryActionText: app.user.Role >= 91 ? "Authorise Override?" : "Check Engineering",
                tertiaryAction: app.user.Role >= 91 ? overrideEngineeringAction : confirmEngineeringAction,
            };

            if (!(user.Role < 10 && adminOnly)) {
                dialog = {
                    ...dialog,
                    secondaryActionText: "Cancel",
                    secondaryAction: () => {
                        reject();
                    },
                };
            }
            setDialogData(dialog);

            setOpenDialog(true);
        });
    };

    const orderEngineeringAction = () => {
        return new Promise((resolve, reject) => {
            setDialogData({
                title: "Engineering Not Passed",
                message: "Access to documents has been limited until engineering passes.",
                primaryActionText: "Cancel",
                primaryAction: () => {
                    reject();
                },
                tertiaryActionText: app.user.Role >= 91 ? "Authorise Override?" : "",
                tertiaryAction: app.user.Role >= 91 ? overrideEngineeringAction : {},
            });

            setOpenDialog(true);
        });
    };

    const confirmEngineeringAction = () => {
        dispatch(updateLayout2D(null, -1, "engineering", true));
        app.designer.designer3D.drawerToolSetExpanded = "beams_and_posts_tool";
    };

    const defaultFootingChange = (props) => {};

    const defaultPostChange = (props) => {};

    DesignerDrawingWarnings({ props, warningMessages, setWarningMessages, config });

    const closeDrawers = () => {
        setOpeningQuote(false);
        setOpeningOrder(false);
        setBomOpen(false);
    };

    const toggleBomOpen = async (saved = false, quoteIsOpening = false, fast = false) => {
        let bom_was_open = bomOpen;
        let error;

        if (!fast) {
            // No warnings and bom just returns price - admin
            if (!carportMode && !threeDMiniMode && !bomOpen && quoteIsOpening) {
                dispatch(APP.updateDesigner(APP.THREED_MODE, true));
                dispatch(APP.updateDesigner(APP.THREED_MINI_MODE, true));
            }

            setToolSetArea(0, APP.BEAMS_AND_POSTS_TOOL);

            error = await JOBSTATE_VALIDATION.validateJobOrderReadiness({
                job,
                config,
                app,
                user: app.user,
                overrideEngineeringAction,
                continueEngineeringAction,
                confirmEngineeringAction,
                forOrder: openingOrder,
                continueWarningAction,
                defaultFootingChange,
                defaultPostChange,
                bom_was_open,
                dispatch,
            });

            if (error && error.error) {
                openMessageBox(error);
                closeDrawers();
                return;
            }

            if (error.cancel) {
                closeDrawers();
                return;
            }

            if (!bom_was_open) {
                let warnings = await JOBSTATE_VALIDATION.getWarnings(job, app.user, config);

                if (warnings.errors) {
                    warnings.message.push(
                        <>
                            <br />
                            *THERE ARE ERRORS IN THIS DESIGN. PLEASE CORRECT BEFORE PROCEEDING.
                        </>
                    );
                }

                if (!warningsContinue && warnings && warnings.warning) {
                    openMessageBox({
                        ...warnings,
                        secondaryActionText: warnings.errors ? "" : "Ignore (Continue Anyway)",
                        secondaryAction: () => {
                            setWarningsContinue(true);
                            setBomOpen(!bomOpen);
                        },
                    });
                    return;
                }
            }
        }

        setBomOpen(!bomOpen);
        setFast(fast);

        if (bom_was_open) {
            if (openingQuote && saved) {
                setOpeningQuote(false);
                setQuoteOpen(true);
            } else if (openingOrder && saved) {
                setOpeningOrder(false);
                setOrderOpen(true);
            } else {
                setOpeningQuote(false);
            }
            setWarningsContinue(false);
        }
    };

    const toggleQuoteOpen = (fast = false) => {
        if (quoteOpen) {
            setQuoteOpen(!quoteOpen);
            setOpeningQuote(false);
        } else {
            setOpeningQuote(true);
            toggleBomOpen(false, true, fast);
            updateLayoutAll(job, app);
        }
    };

    useEffect(() => {
        if (openingOrder) {
            toggleBomOpen();
            updateLayoutAll(job, app);
        }
    }, [openingOrder]);

    const toggleOrderOpen = async () => {
        let error = await JOBSTATE_VALIDATION.validateJobOrderReadiness({
            job,
            config,
            app,
            user: app.user,
            overrideEngineeringAction,
            confirmEngineeringAction,
            continueEngineeringAction: orderEngineeringAction,
            continueWarningAction,
            defaultPostChange,
            defaultFootingChange,
            dispatch,
        });
        if (error && error.error) {
            openMessageBox(error);
            return;
        }
        if (error.cancel) {
            closeDrawers();
            return;
        }

        if (orderOpen) {
            setOrderOpen(!orderOpen);
            setOpeningOrder(false);
        } else {
            setOpeningOrder(true);
        }
    };

    const toggleGenerateQuoteAndDocumentOpen = () => {
        updateDocumentData(job, "Quote Layout");
        setDocumentOpen("Quote Layout");
        if (["New", "Lead", "Design"].includes(job.Status))
            dispatch(
                updateJobParameter(null, {
                    Status: "Quoted",
                })
            );
        setQuoteOpen(false);
        setOpeningQuote(false);
    };

    const toggleDocumentOpen = async () => {
        let doc_was_open = documentOpen;
        let error = await JOBSTATE_VALIDATION.validateJobOrderReadiness({
            job,
            config,
            app,
            user: app.user,
            overrideEngineeringAction,
            confirmEngineeringAction,
            continueEngineeringAction,
            continueWarningAction,
            defaultPostChange,
            defaultFootingChange,
            bom_was_open: doc_was_open,
            dispatch,
        });
        if (error && error.error) {
            openMessageBox(error);
            return;
        }
        if (error.cancel) {
            closeDrawers();
            return;
        }

        if (documentOpen) {
            props.updateDesigner(APP.GENERATING_DOCUMENT, false);
            props.updateDesigner(APP.DOCUMENT_TO_SHOW, null);
        }

        setDocumentOpen(!documentOpen);
    };

    const { classes, updateDocumentData } = props;
    const THREED_MODE = props.app.designer[APP.THREED_MODE];
    const THREED_MINI_MODE = props.app.designer[APP.THREED_MINI_MODE];
    const DOCUMENT_TO_SHOW = props.app.designer[APP.DOCUMENT_TO_SHOW];
    const GENERATING_DOCUMENT = props.app.designer[APP.GENERATING_DOCUMENT];
    const SHOW_DISPLAY_OPTIONS = props.app.designer[APP.SHOW_DISPLAY_OPTIONS];
    const AREA_INDEX = props.app.designer.designer2D?.[APP.AREA_INDEX];
    const SELECT_POINT = app.designer?.designer2D[APP.SELECT_POINT];
    const SELECT_POINT_NOTE = app.designer?.designer2D[APP.SELECT_POINT_NOTE];
    let last_job_id = "#" + props.job?.id;
    let job_name = props.job?.Customer?.FirstName;
    if (props.job?.Customer?.LastName) job_name += " " + props.job?.Customer?.LastName;
    if (!job_name) job_name = props.job?.Customer?.JobName;
    if (last_job_id && job_name) last_job_id = job_name + " (" + last_job_id + ")";

    const { engValidNoOverride } = JOBSTATE_VALIDATION.engineeringPassed({ job });

    return (
        <div className={classes.root}>
            <LockBar warningMessages={warningMessages} openMessageBox={openMessageBox} />
            <CssBaseline />
            <HeaderBar
                engineeringStatus={engineeringStatus}
                engineeringLoading={engineeringLoading}
                setEngineeringLoading={setEngineeringLoading}
            />
            <Designer_ToolBar
                job_loaded={job_loaded}
                toggleBomOpen={toggleBomOpen}
                toggleQuoteOpen={toggleQuoteOpen}
                toggleDocumentOpen={toggleDocumentOpen}
                toggleOrderOpen={toggleOrderOpen}
            />
            {job_loaded && (
                <>
                    <SpecificationToolDrawer
                        openMessageBox={openMessageBox}
                        setEngineeringStatus={setEngineeringStatus}
                        setEngineeringLoading={setEngineeringLoading}
                        engineeringLoading={engineeringLoading}
                    />
                    {SELECT_POINT !== false && SELECT_POINT_NOTE && (
                        <div className={classes.selectPointNote}>
                            {AREA_INDEX > -1 && (
                                <AreaSelector
                                    multi_view={false}
                                    selectedAreaIndex={AREA_INDEX}
                                    showHeader={false}
                                    onChange={(newArea) => {
                                        dispatch(APP.update2DDesigner(APP.AREA_INDEX, newArea));
                                    }}
                                />
                            )}
                            {SELECT_POINT_NOTE}
                        </div>
                    )}
                </>
            )}

            {props.app.designer.SHOW_LOADING_BAR && (
                <div
                    style={{
                        position: "fixed",
                        bottom: "0px",
                        width: "100%",
                        zIndex: "1",
                    }}
                >
                    <Typography classes={{ root: classes.calculating }} variant="caption" display="block" gutterBottom>
                        Calculating...
                    </Typography>
                    <LinearProgress style={{ marginTop: "0px", height: "20px" }} color={"primary"} />
                </div>
            )}
            {job_loaded && (
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <LayoutDesigner visible={!THREED_MODE || (THREED_MODE && THREED_MINI_MODE)} />
                </main>
            )}

            <Drawer
                key={SHOW_CUSTOMER_JOB_PANEL}
                anchor="left"
                open={SHOW_CUSTOMER_JOB_PANEL}
                onClose={() => setTriggerCustoomerFormClose(true)}
            >
                <BSL_HelpLysaght />
                <NewJob job={props.job} close={triggerCustoomerFormClose} mode="Edit" />
            </Drawer>

            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                open={open}
                autoHideDuration={4000}
                onClose={handleClose}
                classes={{ root: classes.snackbar }}
            >
                <SnackbarContent
                    classes={{ root: classes.snackbar }}
                    message={message}
                    action={
                        <React.Fragment>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </React.Fragment>
                    }
                />
            </Snackbar>

            <Slide direction="right" in={bomOpen} mountOnEnter unmountOnExit>
                <div className={classes.bom} style={newWidth}>
                    <div
                        id="dragger"
                        onMouseDown={(event) => {
                            handleMousedown(event);
                        }}
                        className={classes.dragger}
                    />
                    {bomOpen && (
                        <BOMFrame
                            fast={fast}
                            toggleBomOpen={toggleBomOpen}
                            confirmButton={
                                openingQuote ? "Confirm and Generate Quote" : openingOrder ? "Confirm and Order" : false
                            }
                            job={props.job}
                            engValid={engValidNoOverride}
                        />
                    )}
                </div>
            </Slide>

            <Slide direction="right" in={quoteOpen} mountOnEnter unmountOnExit>
                <div className={classes.bom} style={newWidth}>
                    <div
                        id="dragger"
                        onMouseDown={(event) => {
                            handleMousedown(event);
                        }}
                        className={classes.dragger}
                    />
                    <QuoteFrame
                        toggleQuoteOpen={toggleQuoteOpen}
                        toggleGenerateQuoteAndDocumentOpen={toggleGenerateQuoteAndDocumentOpen}
                    />
                </div>
            </Slide>

            <Slide direction="right" in={orderOpen} mountOnEnter unmountOnExit>
                <div className={classes.bom} style={newWidth}>
                    <div
                        id="dragger"
                        onMouseDown={(event) => {
                            handleMousedown(event);
                        }}
                        className={classes.dragger}
                    />
                    <OrderJobPanel toggleOpen={toggleOrderOpen} />
                </div>
            </Slide>

            <Slide direction="left" in={SHOW_DISPLAY_OPTIONS} mountOnEnter unmountOnExit>
                <div className={classes.display_options}>
                    <DisplayOptions3D />
                </div>
            </Slide>

            <Drawer anchor="left" open={documentOpen} onClose={() => toggleDocumentOpen()} style={{ zIndex: 9999 }}>
                <div style={DOCUMENT_TO_SHOW ? { ...newWidth, height: "100%" } : { height: "100%" }}>
                    {DOCUMENT_TO_SHOW && (
                        <div
                            id="dragger"
                            onMouseDown={(event) => {
                                handleMousedown(event);
                            }}
                            className={classes.dragger}
                        />
                    )}
                    <DocumentFrame
                        toggleDocumentOpen={toggleDocumentOpen}
                        updateDocumentData={updateDocumentData}
                        updateDesigner={props.updateDesigner}
                        DOCUMENT_TO_SHOW={DOCUMENT_TO_SHOW}
                        generatingDocument={GENERATING_DOCUMENT}
                        documentType={typeof documentOpen === "string" ? documentOpen : ""}
                        job={props.job}
                    />
                </div>
            </Drawer>

            <Backdrop className={classes.backdrop} open={props.app.designer.SHOW_LOADING_BACKDROP}>
                {React.isValidElement(props.app.designer.LOADING_BACKDROP_MESSAGE) ? (
                    props.app.designer.LOADING_BACKDROP_MESSAGE
                ) : (
                    <>
                        <CircularProgress color="inherit" style={{ position: "absolute" }} />
                        <br />
                        <Typography variant="overline" gutterBottom style={{ marginTop: "100px" }}>
                            {props.app.designer.LOADING_BACKDROP_MESSAGE}...
                        </Typography>
                    </>
                )}
            </Backdrop>
            <BSL_Dialog
                title={dialogData.title}
                open={openDialog}
                onClose={() => closeMessageBox()}
                button1Id={dialogData?.button1Id}
                button1Text={dialogData?.primaryActionText ? dialogData?.primaryActionText : "OK"}
                button1Click={() => {
                    closeMessageBox();
                    if (dialogData?.primaryAction) dispatch(dialogData.primaryAction);
                }}
                button2Text={dialogData?.secondaryActionText}
                button2Click={() => {
                    closeMessageBox();
                    if (dialogData?.secondaryAction) dispatch(dialogData.secondaryAction);
                }}
                button3Text={dialogData?.tertiaryActionText}
                button3Click={() => {
                    closeMessageBox();
                    if (dialogData?.tertiaryAction) dispatch(dialogData.tertiaryAction);
                }}
            >
                {dialogData.message}
            </BSL_Dialog>
        </div>
    );
}

export default connect(mapStateToProps, importedActions)(withStyles(styles)(Designer));
